import React, { useState } from "react";
import { Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Slide } from "@mui/material";
import { useTranslation } from "react-i18next";
import FileUploader from "../FileUploader/FileUploader";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FileUploaderPopup = (props) => {
    const { t } = useTranslation("translation");
    const [files, setFiles] = useState(props.files ?? []);
    const [copiedFiles, setCopiedFiles] = useState(props.files ?? []);
    const [filesForCompression, setFilesForCompression] = useState([]); // bool list => true: original, false: compressed

    return (
        <Container id="fu_Container">
            <Dialog id="fu_Dialog" open={props.isOpen} onClose={props.onCancel} fullWidth maxWidth="md" TransitionComponent={Transition}>
                <DialogTitle id="fu_DialogTitle">{t("UploadFile")}</DialogTitle>
                <DialogContent id="fu_DialogContent" dividers={true}>
                    <FileUploader
                        files={files}
                        setFiles={setFiles}
                        copiedFiles={copiedFiles}
                        setCopiedFiles={setCopiedFiles}
                        filesForCompression={filesForCompression}
                        setFilesForCompression={setFilesForCompression}
                    />
                </DialogContent>
                <DialogActions id="fu_DialogActions">
                    <Button id="fu_b" onClick={props.onCancel} variant="text" color="error">
                        {t("Cancel")}
                    </Button>
                    <Button id="fu_b_1" onClick={() => props.onConfirm(copiedFiles)} disabled={copiedFiles.length === 0 && !props.files} variant="text" color="primary">
                        {t("UploadFile")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default FileUploaderPopup;
